import React, { FC } from 'react'

import {
  BasicDoughnut,
  DoughnutContent,
  SplitContent,
} from '@acorns/web-components'

import { Portfolio } from 'generated/types'
import {
  PORTFOLIO_BONDS_PERCENTAGE,
  PORTFOLIO_STOCKS_PERCENTAGE,
} from 'utils/testing/testIDs'

import { usePortfolioContent } from '../hooks/usePortfolioContent'
import { MinimalRelativeContainer } from '../styled-components'
import { RootProps } from '../types'
import { LoadingContainer } from './LoadingContainer'

export type OnboardingContentProps = RootProps & { portfolio: Portfolio }

export const OnboardingContent: FC<OnboardingContentProps> = ({
  header,
  portfolio,
  portfolios,
  graphData,
  selectedView,
  setSelectedEtf,
}) => {
  const {
    totalBondsPercentage,
    totalStocksPercentage,
    handleSelectedDataChange,
    chartData,
    chartArcColors,
  } = usePortfolioContent({
    portfolio,
    graphData,
    selectedView,
    setSelectedEtf,
  })

  return (
    <>
      <LoadingContainer portfolios={portfolios}>
        {header}
        <MinimalRelativeContainer>
          <BasicDoughnut
            data={chartData}
            colors={chartArcColors}
            height="255px"
            width="255px"
            onItemHighlight={handleSelectedDataChange}
            options={{
              animation: {
                animateRotate: true,
                animateScale: false,
              },
              round: true,
            }}
          >
            <DoughnutContent
              defaultContent={
                <SplitContent
                  topContent={[
                    {
                      value: totalBondsPercentage,
                      label: 'Bonds',
                      testId: PORTFOLIO_BONDS_PERCENTAGE,
                    },
                  ]}
                  bottomContent={[
                    {
                      value: totalStocksPercentage,
                      label: 'Stocks',
                      testId: PORTFOLIO_STOCKS_PERCENTAGE,
                    },
                  ]}
                />
              }
            />
          </BasicDoughnut>
        </MinimalRelativeContainer>
      </LoadingContainer>
    </>
  )
}
